/* (v147) REDACT PDF: black boxes that remove what lies under them.
   Every page with at least one box is rendered again as a picture (pdf.js),
   the boxes are painted into its pixels, and that picture replaces the page
   in the file (pdf-lib). Pages without a box are kept as they are. Then
   everything that can hold a hidden copy of text is cleaned (see redactClean)
   and every object nothing points to any more is dropped before saving, so
   the old page content is not left behind in the file. */
(function(){
  'use strict';
  var MSG = {
    en: {
      working: 'Blacking out pages…',
      workingPage: 'Blacking out page {0} of {1}…',
      one: 'Redact one PDF at a time: remove the other files from the list.',
      noBoxes: 'Draw at least one black box first (or find a word), then try again.',
      changed: 'This PDF could not be read the same way twice (it seems damaged), so nothing was blacked out. Save it again from a PDF reader (e.g. print to PDF) and try again.',
      renderFail: 'Page {0} is too large to turn into a picture on this device. Try again on a computer.',
      page: 'Page {0} of {1}',
      countNone: 'No black boxes yet.',
      countOne: '1 black box',
      countPage: '{0} black boxes on 1 page',
      countPages: '{0} black boxes on {1} pages',
      boxLabel: 'Black box {0} on page {1}. Press Delete to remove it.',
      removed: 'Black box removed.',
      undoneOne: 'Black box removed (page {0}).',
      undoneMany: '{0} black boxes removed.',
      undoneHidden: "Undone: page(s) {0} will no longer be turned into a picture.",
      findShort: 'Type at least 2 characters to search.',
      findBusy: 'Searching… page {0} of {1}',
      findNone: 'No matches. Text in a scan or picture can\'t be found: draw a box over it by hand.',
      findOne: '1 match found and covered on page {0}. Check it in the preview.',
      findMany: '{0} matches covered on {1} page(s). Check every page in the preview: a match can be cut off, and another spelling is not found.',
      findHidden: "Also found in text nobody can see (a hidden layer, white text or outside the page) on page(s) {0}: those pages are turned into pictures as well, so that text really goes.",
      findAnnot: "Found in comments or form fields too: those are covered and removed with their page.",
      findTooMany: 'More than {0} matches: type a longer search term.',
      findFail: 'This PDF could not be searched. Draw the boxes by hand.',
      infoOne: '1 PDF, 1 page blacked out',
      infoMany: '1 PDF, {0} pages blacked out',
      noteOne: 'Page {0} is now a picture: text there can no longer be selected or searched.',
      noteMany: 'Pages {0} are now pictures: text there can no longer be selected or searched.',
      note: 'Metadata, bookmarks, attachments, document scripts and tags were removed from the file, as were the form fields and comments on those pages. Check the result before you share it.'
    },
    nl: {
      working: 'Pagina\'s zwartlakken…',
      workingPage: 'Pagina {0} van {1} zwartlakken…',
      one: 'Lak één PDF tegelijk zwart: haal de andere bestanden uit de lijst.',
      noBoxes: 'Teken eerst minstens één zwart vak (of zoek een woord) en probeer opnieuw.',
      changed: 'Deze PDF werd niet twee keer op dezelfde manier gelezen (hij lijkt beschadigd), dus er is niets zwartgelakt. Sla hem opnieuw op vanuit een PDF-lezer (bv. afdrukken als PDF) en probeer opnieuw.',
      renderFail: 'Pagina {0} is te groot om op dit toestel een afbeelding van te maken. Probeer het op een computer.',
      page: 'Pagina {0} van {1}',
      countNone: 'Nog geen zwarte vakken.',
      countOne: '1 zwart vak',
      countPage: '{0} zwarte vakken op 1 pagina',
      countPages: '{0} zwarte vakken op {1} pagina\'s',
      boxLabel: 'Zwart vak {0} op pagina {1}. Druk op Delete om het te verwijderen.',
      removed: 'Zwart vak verwijderd.',
      undoneOne: 'Zwart vak verwijderd (pagina {0}).',
      undoneMany: '{0} zwarte vakken verwijderd.',
      undoneHidden: "Ongedaan: pagina('s) {0} worden niet meer omgezet in een afbeelding.",
      findShort: 'Typ minstens 2 tekens om te zoeken.',
      findBusy: 'Zoeken… pagina {0} van {1}',
      findNone: 'Niets gevonden. Tekst in een scan of afbeelding is niet te vinden: teken er zelf een vak over.',
      findOne: '1 treffer gevonden en afgedekt op pagina {0}. Kijk hem na in het voorbeeld.',
      findMany: '{0} treffers afgedekt op {1} pagina(\'s). Kijk elke pagina na in het voorbeeld: een treffer kan afgebroken zijn, en een andere schrijfwijze wordt niet gevonden.',
      findHidden: "Ook gevonden in tekst die niemand ziet (een verborgen laag, witte tekst of buiten de pagina) op pagina('s) {0}: die pagina's worden ook een afbeelding, zodat die tekst echt verdwijnt.",
      findAnnot: "Ook gevonden in opmerkingen of formuliervelden: die worden afgedekt en met hun pagina verwijderd.",
      findTooMany: 'Meer dan {0} treffers: typ een langere zoekterm.',
      findFail: 'In deze PDF kon niet gezocht worden. Teken de vakken zelf.',
      infoOne: '1 PDF, 1 pagina zwartgelakt',
      infoMany: '1 PDF, {0} pagina\'s zwartgelakt',
      noteOne: 'Pagina {0} is nu een afbeelding: daar kun je geen tekst meer selecteren of doorzoeken.',
      noteMany: 'Pagina\'s {0} zijn nu afbeeldingen: daar kun je geen tekst meer selecteren of doorzoeken.',
      note: 'Metadata, bladwijzers, bijlagen, documentscripts en tags zijn uit het bestand verwijderd, net als de formuliervelden en opmerkingen op die pagina\'s. Kijk het resultaat na voor je het deelt.'
    },
    fr: {
      working: 'Caviardage des pages…',
      workingPage: 'Caviardage de la page {0} sur {1}…',
      one: 'Caviardez un PDF à la fois : retirez les autres fichiers de la liste.',
      noBoxes: 'Dessinez d’abord au moins un cadre noir (ou cherchez un mot), puis réessayez.',
      changed: 'Ce PDF n’a pas pu être lu deux fois de la même manière (il semble endommagé) : rien n’a été caviardé. Enregistrez-le à nouveau depuis un lecteur PDF (p. ex. imprimer en PDF) et réessayez.',
      renderFail: 'La page {0} est trop grande pour être transformée en image sur cet appareil. Réessayez sur un ordinateur.',
      page: 'Page {0} sur {1}',
      countNone: 'Pas encore de cadre noir.',
      countOne: '1 cadre noir',
      countPage: '{0} cadres noirs sur 1 page',
      countPages: '{0} cadres noirs sur {1} pages',
      boxLabel: 'Cadre noir {0} sur la page {1}. Appuyez sur Suppr pour le retirer.',
      removed: 'Cadre noir retiré.',
      undoneOne: 'Cadre noir retiré (page {0}).',
      undoneMany: '{0} cadres noirs retirés.',
      undoneHidden: "Annulé : la ou les pages {0} ne seront plus transformées en image.",
      findShort: 'Tapez au moins 2 caractères pour chercher.',
      findBusy: 'Recherche… page {0} sur {1}',
      findNone: 'Aucun résultat. Le texte d’un scan ou d’une image est introuvable : dessinez vous-même un cadre dessus.',
      findOne: '1 occurrence trouvée et couverte en page {0}. Vérifiez-la dans l’aperçu.',
      findMany: '{0} occurrences couvertes sur {1} page(s). Vérifiez chaque page dans l’aperçu : une occurrence peut être coupée, et une autre orthographe n’est pas trouvée.',
      findHidden: "Aussi trouvé dans du texte invisible (calque masqué, texte blanc ou hors de la page) en page(s) {0} : ces pages deviennent aussi des images, pour que ce texte disparaisse vraiment.",
      findAnnot: "Aussi trouvé dans des commentaires ou champs de formulaire : ils sont masqués et supprimés avec leur page.",
      findTooMany: 'Plus de {0} occurrences : tapez un terme plus long.',
      findFail: 'Impossible de chercher dans ce PDF. Dessinez les cadres vous-même.',
      infoOne: '1 PDF, 1 page caviardée',
      infoMany: '1 PDF, {0} pages caviardées',
      noteOne: 'La page {0} est maintenant une image : le texte n’y est plus sélectionnable ni consultable par recherche.',
      noteMany: 'Les pages {0} sont maintenant des images : le texte n’y est plus sélectionnable ni consultable par recherche.',
      note: 'Les métadonnées, signets, pièces jointes, scripts du document et balises ont été retirés du fichier, ainsi que les champs de formulaire et commentaires de ces pages. Vérifiez le résultat avant de le partager.'
    },
    de: {
      working: 'Seiten werden geschwärzt…',
      workingPage: 'Seite {0} von {1} wird geschwärzt…',
      one: 'Schwärzen Sie immer nur ein PDF: Entfernen Sie die anderen Dateien aus der Liste.',
      noBoxes: 'Zeichnen Sie zuerst mindestens einen schwarzen Kasten (oder suchen Sie ein Wort) und versuchen Sie es dann erneut.',
      changed: 'Dieses PDF ließ sich nicht zweimal gleich lesen (es scheint beschädigt), daher wurde nichts geschwärzt. Speichern Sie es in einem PDF-Reader neu (z. B. als PDF drucken) und versuchen Sie es erneut.',
      renderFail: 'Seite {0} ist zu groß, um auf diesem Gerät in ein Bild umgewandelt zu werden. Versuchen Sie es an einem Computer.',
      page: 'Seite {0} von {1}',
      countNone: 'Noch keine schwarzen Kästen.',
      countOne: '1 schwarzer Kasten',
      countPage: '{0} schwarze Kästen auf 1 Seite',
      countPages: '{0} schwarze Kästen auf {1} Seiten',
      boxLabel: 'Schwarzer Kasten {0} auf Seite {1}. Mit Entf entfernen.',
      removed: 'Schwarzer Kasten entfernt.',
      undoneOne: 'Schwarzer Kasten entfernt (Seite {0}).',
      undoneMany: '{0} schwarze Kästen entfernt.',
      undoneHidden: "Rückgängig: Seite(n) {0} werden nicht mehr in ein Bild umgewandelt.",
      findShort: 'Geben Sie mindestens 2 Zeichen ein.',
      findBusy: 'Suche… Seite {0} von {1}',
      findNone: 'Keine Treffer. Text in einem Scan oder Bild wird nicht gefunden: Zeichnen Sie selbst einen Kasten darüber.',
      findOne: '1 Treffer gefunden und auf Seite {0} abgedeckt. Prüfen Sie ihn in der Vorschau.',
      findMany: '{0} Treffer auf {1} Seite(n) abgedeckt. Prüfen Sie jede Seite in der Vorschau: Ein Treffer kann abgeschnitten sein, und eine andere Schreibweise wird nicht gefunden.',
      findHidden: "Auch in Text gefunden, den niemand sieht (ausgeblendete Ebene, weißer Text oder außerhalb der Seite) auf Seite(n) {0}: Diese Seiten werden ebenfalls zu Bildern, damit der Text wirklich verschwindet.",
      findAnnot: "Auch in Kommentaren oder Formularfeldern gefunden: Diese werden abgedeckt und mit ihrer Seite entfernt.",
      findTooMany: 'Mehr als {0} Treffer: Geben Sie einen längeren Suchbegriff ein.',
      findFail: 'In diesem PDF kann nicht gesucht werden. Zeichnen Sie die Kästen selbst.',
      infoOne: '1 PDF, 1 Seite geschwärzt',
      infoMany: '1 PDF, {0} Seiten geschwärzt',
      noteOne: 'Seite {0} ist jetzt ein Bild: Dort lässt sich kein Text mehr markieren oder durchsuchen.',
      noteMany: 'Die Seiten {0} sind jetzt Bilder: Dort lässt sich kein Text mehr markieren oder durchsuchen.',
      note: 'Metadaten, Lesezeichen, Anhänge, Dokumentskripte und Tags wurden aus der Datei entfernt, ebenso die Formularfelder und Kommentare auf diesen Seiten. Prüfen Sie das Ergebnis, bevor Sie es weitergeben.'
    },
    es: {
      working: 'Censurando páginas…',
      workingPage: 'Censurando la página {0} de {1}…',
      one: 'Censura un PDF cada vez: quita los demás archivos de la lista.',
      noBoxes: 'Dibuja primero al menos un recuadro negro (o busca una palabra) y vuelve a intentarlo.',
      changed: 'Este PDF no se pudo leer dos veces de la misma forma (parece dañado), así que no se ha censurado nada. Vuelve a guardarlo desde un lector de PDF (p. ej. imprimir en PDF) e inténtalo de nuevo.',
      renderFail: 'La página {0} es demasiado grande para convertirla en imagen en este dispositivo. Inténtalo en un ordenador.',
      page: 'Página {0} de {1}',
      countNone: 'Aún no hay recuadros negros.',
      countOne: '1 recuadro negro',
      countPage: '{0} recuadros negros en 1 página',
      countPages: '{0} recuadros negros en {1} páginas',
      boxLabel: 'Recuadro negro {0} en la página {1}. Pulsa Supr para quitarlo.',
      removed: 'Recuadro negro quitado.',
      undoneOne: 'Recuadro negro quitado (página {0}).',
      undoneMany: '{0} recuadros negros quitados.',
      undoneHidden: "Deshecho: la(s) página(s) {0} ya no se convertirán en imagen.",
      findShort: 'Escribe al menos 2 caracteres para buscar.',
      findBusy: 'Buscando… página {0} de {1}',
      findNone: 'No hay coincidencias. El texto de un escaneo o una imagen no se puede encontrar: dibuja tú un recuadro encima.',
      findOne: '1 coincidencia encontrada y cubierta en la página {0}. Revísala en la vista previa.',
      findMany: '{0} coincidencias cubiertas en {1} página(s). Revisa cada página en la vista previa: una coincidencia puede quedar cortada y otra forma de escribirla no se encuentra.',
      findHidden: "También se encontró en texto que nadie ve (una capa oculta, texto blanco o fuera de la página) en la(s) página(s) {0}: esas páginas también se convierten en imagen, para que ese texto desaparezca de verdad.",
      findAnnot: "También se encontró en comentarios o campos de formulario: se tapan y se eliminan con su página.",
      findTooMany: 'Más de {0} coincidencias: escribe un término más largo.',
      findFail: 'No se ha podido buscar en este PDF. Dibuja los recuadros a mano.',
      infoOne: '1 PDF, 1 página censurada',
      infoMany: '1 PDF, {0} páginas censuradas',
      noteOne: 'La página {0} ahora es una imagen: ya no se puede seleccionar ni buscar texto en ella.',
      noteMany: 'Las páginas {0} ahora son imágenes: ya no se puede seleccionar ni buscar texto en ellas.',
      note: 'Se han quitado del archivo los metadatos, marcadores, adjuntos, scripts del documento y etiquetas, además de los campos de formulario y comentarios de esas páginas. Revisa el resultado antes de compartirlo.'
    },
    pt: {
      working: 'Tarjando páginas…',
      workingPage: 'Tarjando a página {0} de {1}…',
      one: 'Tarje um PDF de cada vez: remova os outros arquivos da lista.',
      noBoxes: 'Desenhe primeiro pelo menos uma tarja preta (ou busque uma palavra) e tente de novo.',
      changed: 'Não foi possível ler este PDF duas vezes do mesmo jeito (ele parece danificado), então nada foi tarjado. Salve-o de novo em um leitor de PDF (por ex. imprimir como PDF) e tente outra vez.',
      renderFail: 'A página {0} é grande demais para virar imagem neste aparelho. Tente em um computador.',
      page: 'Página {0} de {1}',
      countNone: 'Nenhuma tarja preta ainda.',
      countOne: '1 tarja preta',
      countPage: '{0} tarjas pretas em 1 página',
      countPages: '{0} tarjas pretas em {1} páginas',
      boxLabel: 'Tarja preta {0} na página {1}. Pressione Delete para removê-la.',
      removed: 'Tarja preta removida.',
      undoneOne: 'Tarja preta removida (página {0}).',
      undoneMany: '{0} tarjas pretas removidas.',
      undoneHidden: "Desfeito: a(s) página(s) {0} não serão mais convertidas em imagem.",
      findShort: 'Digite pelo menos 2 caracteres para buscar.',
      findBusy: 'Buscando… página {0} de {1}',
      findNone: 'Nenhum resultado. Texto em uma digitalização ou imagem não pode ser encontrado: desenhe você mesmo uma tarja sobre ele.',
      findOne: '1 ocorrência encontrada e coberta na página {0}. Confira na pré-visualização.',
      findMany: '{0} ocorrências cobertas em {1} página(s). Confira cada página na pré-visualização: uma ocorrência pode ficar cortada, e outra grafia não é encontrada.',
      findHidden: "Também encontrado em texto que ninguém vê (camada oculta, texto branco ou fora da página) na(s) página(s) {0}: essas páginas também viram imagem, para que esse texto desapareça de verdade.",
      findAnnot: "Também encontrado em comentários ou campos de formulário: são cobertos e removidos com a página.",
      findTooMany: 'Mais de {0} ocorrências: digite um termo mais longo.',
      findFail: 'Não foi possível buscar neste PDF. Desenhe as tarjas à mão.',
      infoOne: '1 PDF, 1 página tarjada',
      infoMany: '1 PDF, {0} páginas tarjadas',
      noteOne: 'A página {0} agora é uma imagem: não dá mais para selecionar ou buscar texto nela.',
      noteMany: 'As páginas {0} agora são imagens: não dá mais para selecionar ou buscar texto nelas.',
      note: 'Metadados, marcadores, anexos, scripts do documento e tags foram removidos do arquivo, assim como os campos de formulário e comentários dessas páginas. Confira o resultado antes de compartilhar.'
    },
    it: {
      working: 'Oscuramento delle pagine…',
      workingPage: 'Oscuramento della pagina {0} di {1}…',
      one: 'Oscura un PDF alla volta: togli gli altri file dall\'elenco.',
      noBoxes: 'Disegna prima almeno un riquadro nero (o cerca una parola), poi riprova.',
      changed: 'Questo PDF non si è potuto leggere due volte allo stesso modo (sembra danneggiato), quindi non è stato oscurato nulla. Salvalo di nuovo da un lettore PDF (per es. stampa in PDF) e riprova.',
      renderFail: 'La pagina {0} è troppo grande per diventare un\'immagine su questo dispositivo. Riprova da un computer.',
      page: 'Pagina {0} di {1}',
      countNone: 'Ancora nessun riquadro nero.',
      countOne: '1 riquadro nero',
      countPage: '{0} riquadri neri su 1 pagina',
      countPages: '{0} riquadri neri su {1} pagine',
      boxLabel: 'Riquadro nero {0} a pagina {1}. Premi Canc per toglierlo.',
      removed: 'Riquadro nero tolto.',
      undoneOne: 'Riquadro nero tolto (pagina {0}).',
      undoneMany: '{0} riquadri neri tolti.',
      undoneHidden: "Annullato: le pagine {0} non verranno più trasformate in immagine.",
      findShort: 'Scrivi almeno 2 caratteri per cercare.',
      findBusy: 'Ricerca… pagina {0} di {1}',
      findNone: 'Nessun risultato. Il testo in una scansione o in un\'immagine non si trova: disegnaci sopra un riquadro a mano.',
      findOne: '1 risultato trovato e coperto a pagina {0}. Controllalo nell\'anteprima.',
      findMany: '{0} risultati coperti su {1} pagina/e. Controlla ogni pagina nell\'anteprima: un risultato può essere tagliato e un\'altra grafia non viene trovata.',
      findHidden: "Trovato anche in testo che nessuno vede (un livello nascosto, testo bianco o fuori dalla pagina) a pagina {0}: anche quelle pagine diventano immagini, così quel testo sparisce davvero.",
      findAnnot: "Trovato anche in commenti o campi modulo: vengono coperti e rimossi con la loro pagina.",
      findTooMany: 'Più di {0} risultati: scrivi un termine più lungo.',
      findFail: 'Non è stato possibile cercare in questo PDF. Disegna i riquadri a mano.',
      infoOne: '1 PDF, 1 pagina oscurata',
      infoMany: '1 PDF, {0} pagine oscurate',
      noteOne: 'La pagina {0} ora è un\'immagine: lì non si può più selezionare né cercare il testo.',
      noteMany: 'Le pagine {0} ora sono immagini: lì non si può più selezionare né cercare il testo.',
      note: 'Metadati, segnalibri, allegati, script del documento e tag sono stati tolti dal file, così come i campi modulo e i commenti di quelle pagine. Controlla il risultato prima di condividerlo.'
    }, pl: {
      working: "Zaczernianie stron…",
      workingPage: "Zaczernianie strony {0} z {1}…",
      one: "Zaczerniaj jeden PDF naraz: usuń pozostałe pliki z listy.",
      noBoxes: "Najpierw narysuj co najmniej jeden czarny prostokąt (albo wyszukaj słowo), a potem spróbuj ponownie.",
      changed: "Tego PDF nie udało się odczytać dwa razy w ten sam sposób (wygląda na uszkodzony), więc nic nie zostało zaczernione. Zapisz go ponownie w czytniku PDF (np. drukując do PDF) i spróbuj jeszcze raz.",
      renderFail: "Strona {0} jest za duża, żeby zamienić ją w obraz na tym urządzeniu. Spróbuj na komputerze.",
      page: "Strona {0} z {1}",
      countNone: "Nie ma jeszcze czarnych prostokątów.",
      countOne: "1 czarny prostokąt",
      countPage: "{0} {0#czarny prostokąt|czarne prostokąty|czarnych prostokątów} na 1 stronie",
      countPages: "{0} {0#czarny prostokąt|czarne prostokąty|czarnych prostokątów} na {1} {1#stronie|stronach|stronach}",
      boxLabel: "Czarny prostokąt {0} na stronie {1}. Naciśnij Delete, aby go usunąć.",
      removed: "Usunięto czarny prostokąt.",
      undoneOne: "Usunięto czarny prostokąt (strona {0}).",
      undoneMany: "Usunięto {0} {0#czarny prostokąt|czarne prostokąty|czarnych prostokątów}.",
      undoneHidden: "Cofnięto: strony {0} nie zostaną już zamienione na obraz.",
      findShort: "Wpisz co najmniej 2 znaki, aby wyszukać.",
      findBusy: "Wyszukiwanie… strona {0} z {1}",
      findNone: "Brak wyników. Tekstu na skanie lub w obrazie nie da się znaleźć: narysuj na nim prostokąt ręcznie.",
      findOne: "Znaleziono i zakryto 1 wynik na stronie {0}. Sprawdź go w podglądzie.",
      findMany: "Zakryto {0} {0#wynik|wyniki|wyników} na {1} {1#stronie|stronach|stronach}. Sprawdź każdą stronę w podglądzie: wynik może być ucięty, a inny zapis nie zostanie znaleziony.",
      findHidden: "Znaleziono też w tekście, którego nikt nie widzi (ukryta warstwa, biały tekst lub poza stroną) na stronach: {0}. Te strony również stają się obrazami, więc ten tekst naprawdę znika.",
      findAnnot: "Znaleziono też w komentarzach lub polach formularza: zostają zakryte i usunięte razem ze stroną.",
      findTooMany: "Ponad {0} wyników: wpisz dłuższe wyrażenie.",
      findFail: "Nie udało się przeszukać tego PDF. Narysuj prostokąty ręcznie.",
      infoOne: "1 PDF, zaczerniono 1 stronę",
      infoMany: "1 PDF, zaczerniono {0} {0#stronę|strony|stron}",
      noteOne: "Strona {0} jest teraz obrazem: nie da się tam już zaznaczać ani wyszukiwać tekstu.",
      noteMany: "Strony {0} są teraz obrazami: nie da się tam już zaznaczać ani wyszukiwać tekstu.",
      note: "Z pliku usunięto metadane, zakładki, załączniki, skrypty dokumentu i tagi, a także pola formularza i komentarze z tych stron. Sprawdź wynik, zanim go udostępnisz."
    }
  };
  var LANG = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var M = MSG[LANG] || MSG.en;
  function t(key){
    var s = M[key] != null ? M[key] : MSG.en[key];
    return pcFill.apply(null, [s].concat(Array.prototype.slice.call(arguments, 1)));
  }
  function ownError(key){
    var e = new Error(t.apply(null, arguments));
    e.userFacing = true;
    return e;
  }
  var $ = function(id){ return document.getElementById(id); };
  function el(id){ return $('redact-' + id); }

  var R = {
    DPI: 200, PT_PER_INCH: 72,
    // the largest picture per page: within every browser's canvas limits (iPhone: 16.7 MP), less on a phone
    MAX_PX: pcIsPhone() ? 8e6 : 16e6, MAX_SIDE: 8000,
    JPEG_Q: 0.85, PNG_SLACK: 1.25,  // PNG (sharp text) unless it is more than 25 % bigger than the JPEG
    PAD_PX: 1,                       // a box is painted one pixel wider on each side (anti-aliased edges)
    MIN_BOX_PX: 4,                   // a smaller drag is a click, not a box
    PREVIEW_MAX_W: 560, PREVIEW_MAX_SCALE: 2.5, MAX_DPR: 2, RESIZE_MS: 150,
    FIND_MIN: 2, FIND_MAX: 2000,
    // around a found word, in font sizes: below the baseline, above it, and before/after (a width estimate)
    DESCENT: 0.3, ASCENT: 1.0, SIDE: 0.2, VERTICAL_HALF: 0.6,
    MEASURE_PX: 100
  };
  var rd = { pdf: null, page: 1, pages: 0, previewFor: null, rendering: 0, cssW: 0,
    boxFile: null, boxes: new Map(), history: [], nextId: 1, selected: 0, findSeq: 0, draft: null,
    forced: new Set() }; // (v157) pages turned into pictures for a hidden match (no box of their own)

  /* ---------- the boxes (fractions of the page as the reader sees it) ---------- */
  function boxCount(){ var n = 0; rd.boxes.forEach(function(list){ n += list.length; }); return n; }
  function boxesOn(page){ return rd.boxes.get(page) || []; }
  function resetBoxes(file){
    rd.boxFile = file; rd.boxes = new Map(); rd.history = []; rd.selected = 0; rd.page = 1; rd.forced = new Set();
  }
  function addBoxes(list, forced){
    forced = forced || [];
    if(!list.length && !forced.length) return;
    forced.forEach(function(n){ rd.forced.add(n); });
    var ids = list.map(function(b){
      var box = { id: rd.nextId++, page: b.page, x: b.x, y: b.y, w: b.w, h: b.h };
      rd.boxes.set(b.page, boxesOn(b.page).concat([box]));
      return box.id;
    });
    ids.forced = forced; // (review v157) undone with the boxes of the same search
    rd.history.push(ids);
    showBoxes();
  }
  function removeBox(id){
    var hit = null;
    rd.boxes.forEach(function(list, page){
      var keep = list.filter(function(b){ if(b.id === id){ hit = b; return false; } return true; });
      if(keep.length) rd.boxes.set(page, keep); else rd.boxes.delete(page);
    });
    if(rd.selected === id) rd.selected = 0;
    return hit;
  }
  function undo(){
    while(rd.history.length){
      var entry = rd.history.pop(), gone = entry.map(removeBox).filter(Boolean);
      (entry.forced || []).forEach(function(n){ rd.forced.delete(n); });
      if(!gone.length){ if((entry.forced || []).length){ pcAnnounce(t('undoneHidden', entry.forced.join(', '))); return; } continue; } // those boxes were already removed one by one
      if(gone[0].page !== rd.page && rd.pdf){ rd.page = gone[0].page; rerender(); }
      showBoxes();
      pcAnnounce(gone.length === 1 ? t('undoneOne', gone[0].page) : t('undoneMany', gone.length));
      return;
    }
  }
  function countText(){
    var n = boxCount(), pages = rd.boxes.size;
    if(!n) return t('countNone');
    if(n === 1) return t('countOne');
    return pages === 1 ? t('countPage', n) : t('countPages', n, pages);
  }
  function pct(v){ return (Math.max(0, Math.min(1, v)) * 100).toFixed(3) + '%'; }
  function place(node, b){
    node.style.left = pct(b.x); node.style.top = pct(b.y); node.style.width = pct(b.w); node.style.height = pct(b.h);
  }
  function boxButton(b, n){
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'redact-box' + (b.id === rd.selected ? ' selected' : '');
    btn.dataset.id = String(b.id);
    btn.setAttribute('aria-label', t('boxLabel', n, b.page));
    place(btn, b);
    return btn;
  }
  /* The boxes of the page shown, the counter and the buttons. */
  function showBoxes(){
    var layer = el('layer');
    if(!layer) return;
    var focused = document.activeElement && document.activeElement.classList.contains('redact-box') ? +document.activeElement.dataset.id : 0;
    layer.replaceChildren.apply(layer, boxesOn(rd.page).map(function(b, i){ return boxButton(b, i + 1); }));
    if(focused){ var again = layer.querySelector('[data-id="' + focused + '"]'); if(again) again.focus(); }
    el('count').textContent = countText();
    el('undo').disabled = !rd.history.length || !boxCount();
    el('remove').disabled = !rd.selected;
  }
  function select(id){
    rd.selected = id;
    el('layer').querySelectorAll('.redact-box').forEach(function(b){ b.classList.toggle('selected', +b.dataset.id === id); });
    el('remove').disabled = !id;
  }
  /* Removes one box; the focus moves to the next box of the page, else to the preview's title. */
  function deleteBox(id){
    var list = boxesOn(rd.page), at = list.findIndex(function(b){ return b.id === id; });
    if(!removeBox(id)) return;
    showBoxes();
    var rest = boxesOn(rd.page), next = rest[Math.min(at, rest.length - 1)];
    var target = next ? el('layer').querySelector('[data-id="' + next.id + '"]') : el('place-title');
    if(!next && !target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    if(next) select(next.id);
    target.focus();
    pcAnnounce(t('removed'));
  }

  /* ---------- drawing with mouse, finger or pen ---------- */
  function layerPoint(layer, e){
    var r = layer.getBoundingClientRect();
    return { x: Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)), y: Math.max(0, Math.min(1, (e.clientY - r.top) / r.height)), r: r };
  }
  function draftRect(d, p){
    return { x: Math.min(d.x0, p.x), y: Math.min(d.y0, p.y), w: Math.abs(p.x - d.x0), h: Math.abs(p.y - d.y0) };
  }
  function setupDrawing(layer){
    layer.addEventListener('pointerdown', function(e){
      var box = e.target.closest('.redact-box');
      if(box){ e.preventDefault(); box.focus(); select(+box.dataset.id); return; } // Safari doesn't focus a clicked button
      if(e.button !== 0 || !rd.pdf) return;
      e.preventDefault();
      var p = layerPoint(layer, e), node = document.createElement('div');
      node.className = 'redact-draft';
      layer.appendChild(node);
      rd.draft = { x0: p.x, y0: p.y, node: node, id: e.pointerId };
      place(node, { x: p.x, y: p.y, w: 0, h: 0 });
      layer.setPointerCapture(e.pointerId);
    });
    layer.addEventListener('pointermove', function(e){
      if(!rd.draft || rd.draft.id !== e.pointerId) return;
      place(rd.draft.node, draftRect(rd.draft, layerPoint(layer, e)));
    });
    var finish = function(e, keep){
      var d = rd.draft;
      if(!d || d.id !== e.pointerId) return;
      rd.draft = null;
      d.node.remove();
      if(!keep) return;
      var p = layerPoint(layer, e), b = draftRect(d, p);
      if(b.w * p.r.width < R.MIN_BOX_PX || b.h * p.r.height < R.MIN_BOX_PX) return;
      addBoxes([Object.assign({ page: rd.page }, b)]);
    };
    layer.addEventListener('pointerup', function(e){ finish(e, true); });
    layer.addEventListener('pointercancel', function(e){ finish(e, false); });
    layer.addEventListener('focusin', function(e){ if(e.target.classList.contains('redact-box')) select(+e.target.dataset.id); });
    layer.addEventListener('keydown', function(e){
      var box = e.target.closest('.redact-box');
      if(!box || (e.key !== 'Delete' && e.key !== 'Backspace')) return;
      e.preventDefault();
      deleteBox(+box.dataset.id);
    });
  }

  /* ---------- preview of the PDF (one page at a time) ---------- */
  async function closePreview(){
    var pdf = rd.pdf; rd.pdf = null; rd.pages = 0;
    el('find-btn').disabled = true; // (v153) nothing to search until a document is open again (also while a run works)
    if(pdf){ try{ await pdf.destroy(); }catch(e){ pcLogUnexpected(e); } }
  }
  async function destroyTask(task){
    if(!task) return;
    try{ await task.destroy(); }catch(e){ pcLogUnexpected(e); } // cleanup only
  }
  function showMsg(text){
    var msg = el('preview-error');
    msg.textContent = text; msg.hidden = false;
    pcAnnounce(text, true);
  }
  function clearPreviewPassword(){ var b = $('pc-pvw-redact'); if(b) b.remove(); }
  var openSeq = 0; // (see cropOpenSeq) an older opening that is still loading stops quietly
  async function openPreview(file){
    var my = ++openSeq, pw = PCTools.previewPassword(file); // read now: a run forgets it right after
    rd.previewFor = file;
    rd.findSeq++;
    await closePreview();
    if(file !== rd.boxFile) resetBoxes(file);
    var placeEl = el('place'), task = null;
    if(!placeEl) return;
    el('preview-error').hidden = true;
    clearPreviewPassword();
    el('find-info').textContent = '';
    if(!file){ placeEl.hidden = true; return; }
    placeEl.hidden = false;
    try{
      await pcLoadPdfLibs();
      pcRequirePdfJs();
      task = pcGetDocument(Object.assign(pcPdfSource(new Uint8Array(await file.arrayBuffer())), pw ? { password: pw } : {}));
      var pdf = await task.promise;
      if(my !== openSeq){ await destroyTask(task); return; }
      task._pcDoc = pdf; rd.pdf = pdf; rd.pages = pdf.numPages; rd.page = Math.min(rd.page, rd.pages) || 1;
      el('find-btn').disabled = false;
      await renderPreview();
    }catch(e){
      if(task && rd.pdf !== task._pcDoc) await destroyTask(task);
      if(my !== openSeq) return;
      if(rd.pdf && task && rd.pdf === task._pcDoc) await closePreview();
      el('stage').hidden = true;
      if(e && (e.name === 'PasswordException' || e.pw)){
        PCTools.askPreviewPassword('redact', el('preview-error'), file, !!pw, function(f){ openPreview(f).catch(pcLogUnexpected); }, el('place-title'));
        return;
      }
      previewError(e);
    }
  }
  function previewError(e){
    pcLogUnexpected(e);
    rd.pages = 0;
    showMsg(PCTools.reasonOf(e, 'invalidPdf'));
    el('stage').hidden = true;
  }
  function rerender(){
    var file = rd.previewFor;
    renderPreview().catch(function(e){ if(rd.previewFor === file) previewError(e); });
  }
  async function renderPreview(){
    var pdf = rd.pdf;
    try{ await drawPreview(pdf); }
    catch(e){ if(rd.pdf === pdf) throw e; } // its document was closed meanwhile (a newer preview)
  }
  async function drawPreview(pdf){
    var canvas = el('preview'), stage = el('stage');
    if(!pdf || !canvas) return;
    var ticket = ++rd.rendering;
    var page = await pdf.getPage(rd.page);
    try{
      if(ticket !== rd.rendering) return;
      var vp1 = page.getViewport({ scale: 1 });
      stage.hidden = false;
      var cssW = Math.min(R.PREVIEW_MAX_W, stage.parentElement.clientWidth || R.PREVIEW_MAX_W);
      rd.cssW = cssW;
      var dpr = Math.min(R.MAX_DPR, window.devicePixelRatio || 1);
      var vp = page.getViewport({ scale: fitScale(vp1, Math.min(cssW * dpr / vp1.width, R.PREVIEW_MAX_SCALE)) });
      var off = document.createElement('canvas');
      try{
        off.width = Math.max(1, Math.floor(vp.width)); off.height = Math.max(1, Math.floor(vp.height));
        var g = pcCanvas2d(off);
        g.fillStyle = '#ffffff'; g.fillRect(0, 0, off.width, off.height);
        await page.render({ canvasContext: g, viewport: vp }).promise;
        if(ticket !== rd.rendering) return;
        canvas.width = off.width; canvas.height = off.height;
        canvas.getContext('2d').drawImage(off, 0, 0);
      }finally{ pcReleaseCanvas(off); }
      stage.style.width = cssW + 'px';
      el('pageinfo').textContent = t('page', rd.page, rd.pages);
      pagerButtons();
      showBoxes();
    }finally{ page.cleanup(); }
  }
  /* A scale within the canvas limits of every browser (see canvasScale in tools-more.js). */
  function fitScale(vp1, wanted){
    return Math.min(wanted, R.MAX_SIDE / vp1.width, R.MAX_SIDE / vp1.height, Math.sqrt(R.MAX_PX / (vp1.width * vp1.height)));
  }
  /* A button that becomes disabled under the keyboard focus hands it to the other one (see pagerButtons). */
  function pagerButtons(){
    var prev = el('prev'), next = el('next');
    [[prev, rd.page <= 1, next], [next, rd.page >= rd.pages, prev]].forEach(function(b){
      if(b[1] && document.activeElement === b[0] && !b[2].disabled) b[2].focus();
      b[0].disabled = b[1];
      if(b[1] && document.activeElement === b[0]) b[2].focus();
    });
  }
  function goPage(step){
    var to = rd.page + step;
    if(!rd.pdf || to < 1 || to > rd.pages) return;
    rd.page = to; rd.selected = 0;
    rerender();
  }

  /* ---------- find a word: boxes around every match (pdf.js text) ---------- */
  var measureCtx = null;
  function measure(text, family){
    if(!measureCtx) measureCtx = pcCanvas2d(document.createElement('canvas'));
    measureCtx.font = R.MEASURE_PX + 'px ' + (family || 'sans-serif');
    return measureCtx.measureText(text).width;
  }
  /* Where characters j0..j1 of an item start and end, as fractions of its width:
     measured in a similar font (pdf.js gives only the width of the whole item). */
  function spanOf(item, family, j0, j1){
    var full = measure(item.str, family);
    if(!(full > 0)) return [j0 / item.str.length, j1 / item.str.length];
    return [measure(item.str.slice(0, j0), family) / full, measure(item.str.slice(0, j1), family) / full];
  }
  function unit(x, y, fx, fy){ var l = Math.hypot(x, y); return l ? [x / l, y / l] : [fx, fy]; }
  /* The box (fractions of the viewport) around characters j0..j1 of a text item. */
  function itemBox(item, style, j0, j1, vp){
    var m = item.transform, size = Math.hypot(m[2], m[3]) || item.height || 1;
    var u = unit(m[0], m[1], 1, 0), v = unit(m[2], m[3], -u[1], u[0]);
    var s0, s1, t0, t1, dir, across;
    if(style && style.vertical){ // a vertical line of text: the whole item, top to bottom
      dir = [-v[0], -v[1]]; across = u;
      s0 = -R.SIDE * size; s1 = (item.height || size) + R.SIDE * size; t0 = -R.VERTICAL_HALF * size; t1 = R.VERTICAL_HALF * size;
    }else{
      var span = spanOf(item, style && style.fontFamily, j0, j1);
      dir = u; across = v;
      s0 = span[0] * item.width - R.SIDE * size; s1 = span[1] * item.width + R.SIDE * size;
      t0 = -R.DESCENT * size; t1 = R.ASCENT * size;
    }
    var xs = [], ys = [];
    [[s0, t0], [s1, t0], [s0, t1], [s1, t1]].forEach(function(c){
      var p = vp.convertToViewportPoint(m[4] + dir[0] * c[0] + across[0] * c[1], m[5] + dir[1] * c[0] + across[1] * c[1]);
      xs.push(p[0] / vp.width); ys.push(p[1] / vp.height);
    });
    var x0 = Math.max(0, Math.min.apply(null, xs)), y0 = Math.max(0, Math.min.apply(null, ys));
    var x1 = Math.min(1, Math.max.apply(null, xs)), y1 = Math.min(1, Math.max.apply(null, ys));
    return x1 > x0 && y1 > y0 ? { x: x0, y: y0, w: x1 - x0, h: y1 - y0 } : null;
  }
  /* One char lower-cased, but never into two (the map from text to items stays one to one). */
  function fold(c){ var l = c.toLowerCase(); return l.length === 1 ? l : c; }
  function normalized(text){ return Array.from(text).filter(function(c){ return !/\s/.test(c); }).map(fold).join(''); }
  /* The page's text without spaces and lower-cased, with for each character the item and index it came from:
     a match may run over several items ("John" "Doe"), case and spacing don't matter. */
  function pageIndex(items){
    var chars = [], where = [];
    items.forEach(function(it, k){
      if(typeof it.str !== 'string') return; // a marked-content marker
      for(var j = 0; j < it.str.length; j++){
        var c = it.str[j];
        if(/\s/.test(c)) continue;
        chars.push(fold(c)); where.push([k, j]);
      }
    });
    return { text: chars.join(''), where: where };
  }
  /* The boxes for one match: one per item it touches. */
  function matchBoxes(content, idx, at, len, vp, page){
    var parts = new Map();
    for(var i = at; i < at + len; i++){
      var w = idx.where[i], p = parts.get(w[0]);
      if(p) p[1] = w[1] + 1; else parts.set(w[0], [w[1], w[1] + 1]);
    }
    var out = [];
    parts.forEach(function(r, k){
      var item = content.items[k], b = itemBox(item, content.styles[item.fontName], r[0], r[1], vp);
      if(b) out.push(Object.assign({ page: page }, b));
    });
    return out;
  }
  function countIn(text, needle){ var n = 0; for(var at = text.indexOf(needle); at >= 0; at = text.indexOf(needle, at + needle.length)) n++; return n; }
  /* (v157) What the search can't box: the same text where nobody sees it
     (pcAllText: a switched-off layer, white text, outside the crop box),
     and comments or form values (annotations) with it. */
  /* (v157) pdf.js gives no text outside the crop box at all, so the search
     reads a copy of the file whose pages show their whole media box; null
     when no page is cropped. */
  async function uncroppedCopy(file){
    // (review v157) with the preview's password, and opened directly (not loadPdfLib: no notes for a search copy)
    var doc = (await openPdfForEdit(new Uint8Array(await file.arrayBuffer()), PCTools.previewPassword(file) || null)).doc, changed = false;
    doc.getPages().forEach(function(p){
      var c = p.getCropBox(), m = p.getMediaBox();
      if(c.x !== m.x || c.y !== m.y || c.width !== m.width || c.height !== m.height){ p.setCropBox(m.x, m.y, m.width, m.height); changed = true; }
    });
    if(!changed) return null;
    var task = pcGetDocument(pcPdfSource(await doc.save()));
    var pdf = await task.promise;
    return { pdf: pdf, task: task };
  }
  async function hiddenOnPage(page, needle, visibleHits, vp, n, wide){
    var wp = wide ? await wide.pdf.getPage(n) : page;
    var all;
    try{ all = await wp.getTextContent({ pcAllText: true }); }finally{ if(wp !== page) wp.cleanup(); }
    var hidden = countIn(pageIndex(all.items).text, needle) > visibleHits;
    var boxes = [];
    (await page.getAnnotations()).forEach(function(a){
      var text = [a.contentsObj && a.contentsObj.str, a.titleObj && a.titleObj.str, a.fieldValue, a.alternativeText, a.textContent && a.textContent.join(' ')]
        .filter(function(v){ return typeof v === 'string'; }).join(' ');
      if(!a.rect || normalized(text).indexOf(needle) < 0) return;
      var r = vp.convertToViewportRectangle(a.rect);
      var x0 = Math.max(0, Math.min(r[0], r[2]) / vp.width), y0 = Math.max(0, Math.min(r[1], r[3]) / vp.height);
      var x1 = Math.min(1, Math.max(r[0], r[2]) / vp.width), y1 = Math.min(1, Math.max(r[1], r[3]) / vp.height);
      boxes.push(x1 > x0 && y1 > y0 ? { page: n, x: x0, y: y0, w: x1 - x0, h: y1 - y0 } : null);
    });
    return { hidden: hidden || boxes.length > 0, annots: boxes.length, boxes: boxes.filter(Boolean) }; // (review v157) a comment only goes with its page: that page always becomes a picture
  }
  async function findOnPage(pdf, n, needle, wide){
    var page = await pdf.getPage(n);
    try{
      var content = await page.getTextContent();
      var vp = page.getViewport({ scale: 1 }), idx = pageIndex(content.items), out = [], hits = 0;
      for(var at = idx.text.indexOf(needle); at >= 0; at = idx.text.indexOf(needle, at + needle.length)){
        hits++;
        out.push.apply(out, matchBoxes(content, idx, at, needle.length, vp, n));
      }
      var h = await hiddenOnPage(page, needle, hits, vp, n, wide);
      return { boxes: out.concat(h.boxes), hits: hits + h.annots, hidden: h.hidden, annots: h.annots };
    }finally{ page.cleanup(); }
  }
  async function find(){
    var info = el('find-info'), input = el('find'), btn = el('find-btn');
    var needle = normalized(input.value);
    if(needle.length < R.FIND_MIN){ info.textContent = t('findShort'); input.focus(); return; }
    var pdf = rd.pdf, my = ++rd.findSeq;
    if(!pdf) return;
    var found = [], hits = 0, pagesHit = [], hiddenPages = [], annots = 0, wide = null;
    btn.disabled = true;
    try{
      wide = await uncroppedCopy(rd.previewFor);
      if(my !== rd.findSeq) return;
      for(var n = 1; n <= pdf.numPages; n++){
        info.textContent = t('findBusy', n, pdf.numPages);
        var r = await findOnPage(pdf, n, needle, wide);
        if(my !== rd.findSeq) return; // another file, search or run started
        if(r.hits) pagesHit.push(n);
        if(r.hidden) hiddenPages.push(n);
        annots += r.annots;
        hits += r.hits; found = found.concat(r.boxes);
        if(hits > R.FIND_MAX){ info.textContent = t('findTooMany', R.FIND_MAX); return; }
      }
    }catch(e){
      if(my !== rd.findSeq || pdf !== rd.pdf) return; // its document was closed meanwhile
      pcLogUnexpected(e);
      info.textContent = t('findFail');
      return;
    }finally{
      if(wide) await destroyTask(wide.task);
      if(my === rd.findSeq) btn.disabled = false;
    }
    reportFind(found, hits, pagesHit, hiddenPages, annots);
  }
  function reportFind(found, hits, pagesHit, hiddenPages, annots){
    var info = el('find-info');
    var newForced = hiddenPages.filter(function(n){ return !rd.forced.has(n); });
    var extra = [hiddenPages.length ? t('findHidden', hiddenPages.join(', ')) : '', annots ? t('findAnnot') : ''].filter(Boolean).join(' ');
    addBoxes(found, newForced);
    if(!hits){ info.textContent = extra || t('findNone'); return; }
    info.textContent = (hits === 1 ? t('findOne', pagesHit[0]) : t('findMany', hits, pagesHit.length)) + (extra ? ' ' + extra : '');
    if(pagesHit.indexOf(rd.page) < 0){ rd.page = pagesHit[0]; rerender(); }
  }

  /* ---------- the result: boxed pages become pictures ---------- */
  function canvasPng(canvas){
    return new Promise(function(resolve){
      canvas.toBlob(function(b){
        if(!b) return resolve(null);
        b.arrayBuffer().then(function(ab){ resolve(new Uint8Array(ab)); }, function(){ resolve(null); });
      }, 'image/png');
    });
  }
  /* PNG keeps text sharp and is small for documents; a photo or scan is much smaller as JPEG. */
  async function encodePage(canvas, n){
    var jpg = await pcCanvasToJpeg(canvas, R.JPEG_Q);
    var png = await canvasPng(canvas);
    if(!jpg && !png) throw ownError('renderFail', n); // the browser couldn't encode it (memory)
    return png && (!jpg || png.length <= jpg.length * R.PNG_SLACK) ? { bytes: png, png: true } : { bytes: jpg, png: false };
  }
  function paintBoxes(g, boxes, W, H){
    g.fillStyle = '#000000';
    boxes.forEach(function(b){
      var x0 = Math.max(0, Math.floor(b.x * W) - R.PAD_PX), y0 = Math.max(0, Math.floor(b.y * H) - R.PAD_PX);
      var x1 = Math.min(W, Math.ceil((b.x + b.w) * W) + R.PAD_PX), y1 = Math.min(H, Math.ceil((b.y + b.h) * H) + R.PAD_PX);
      g.fillRect(x0, y0, x1 - x0, y1 - y0);
    });
  }
  /* The visible page (crop box, rotation included) as pdf.js shows it, in points. */
  function visibleSize(page){
    var v = page.view, w = v[2] - v[0], h = v[3] - v[1];
    return page.rotate % 180 ? { w: h, h: w } : { w: w, h: h };
  }
  async function renderRedacted(pdfDoc, n, boxes){
    var page = await pdfDoc.getPage(n), canvas = null;
    try{
      var vp1 = page.getViewport({ scale: 1 });
      var vp = page.getViewport({ scale: fitScale(vp1, R.DPI / R.PT_PER_INCH) });
      var W = Math.max(1, Math.floor(vp.width)), H = Math.max(1, Math.floor(vp.height));
      canvas = pcNewCanvas(W, H);
      var g;
      try{ g = pcCanvas2d(canvas); }catch(e){ throw ownError('renderFail', n); }
      g.fillStyle = '#ffffff'; g.fillRect(0, 0, W, H);
      await page.render({ canvasContext: g, viewport: vp }).promise;
      paintBoxes(g, boxes, W, H);
      return Object.assign(await encodePage(canvas, n), { size: visibleSize(page) });
    }finally{ pcReleaseCanvas(canvas); page.cleanup(); }
  }
  /* The page dict is replaced in place (same object number, so links and
     bookmarks to it from other pages still work) by one that only draws the
     picture: no old content, resources, annotations, thumbnail or tags. */
  function replacePage(doc, ref, oldNode, image, size){
    var ctx = doc.context, w = +size.w.toFixed(4), h = +size.h.toFixed(4);
    var content = ctx.register(ctx.stream('q ' + w + ' 0 0 ' + h + ' 0 0 cm /Im0 Do Q'));
    var dict = ctx.obj({ Type: 'Page', MediaBox: [0, 0, w, h], CropBox: [0, 0, w, h], Rotate: 0,
      Resources: { XObject: { Im0: image.ref } }, Contents: content });
    dict.set(pcN('Parent'), oldNode.get(pcN('Parent')));
    var unitScale = oldNode.get(pcN('UserUnit'));
    if(unitScale) dict.set(pcN('UserUnit'), unitScale);
    ctx.assign(ref, dict);
  }
  function annotRefs(node){
    var a = node.lookup(pcN('Annots'));
    return a instanceof PDFLib.PDFArray ? a.asArray().filter(function(r){ return r instanceof PDFLib.PDFRef; }) : [];
  }

  /* ---------- cleaning: what can hold a hidden copy of text ---------- */
  // whole-document parts: associated files (PDF 2.0 attachments), bookmarks (titles), tags (ActualText/Alt), XMP, private app data,
  // document scripts and actions, article threads, portfolios, signature permissions
  var DROP_CATALOG = ['AF', 'Outlines', 'StructTreeRoot', 'MarkInfo', 'Metadata', 'PieceInfo', 'AA', 'Threads', 'SpiderInfo', 'Collection', 'Perms', 'Legal'];
  var DROP_PAGE = ['AF', 'PieceInfo', 'Metadata', 'Thumb', 'AA', 'StructParents', 'B'];
  var DROP_ANNOT_SUBTYPES = ['FileAttachment'];
  function cleanCatalog(doc){
    var ctx = doc.context, cat = doc.catalog;
    DROP_CATALOG.forEach(function(k){ cat.delete(pcN(k)); });
    if(cat.lookup(pcN('OpenAction')) instanceof PDFLib.PDFDict) cat.delete(pcN('OpenAction')); // an action (a script…); a plain destination stays
    var names = cat.lookup(pcN('Names'));
    if(!(names instanceof PDFLib.PDFDict)) return;
    // only named destinations stay (links use them); attachments, scripts, templates… go
    var keep = ctx.obj({}), dests = names.get(pcN('Dests'));
    if(dests) keep.set(pcN('Dests'), dests);
    cat.set(pcN('Names'), keep);
  }
  /* Every /Metadata (XMP) stream anywhere (pages, images, fonts). */
  function dropXmp(ctx){
    var key = pcN('Metadata');
    ctx.enumerateIndirectObjects().forEach(function(pair){
      var o = pair[1], d = o instanceof PDFLib.PDFStream ? o.dict : o;
      if(d instanceof PDFLib.PDFDict) d.delete(key);
    });
  }
  function isField(ctx, ref){ var d = ctx.lookup(ref); return d instanceof PDFLib.PDFDict && d.has(pcN('T')); }
  /* The form fields with a widget on a redacted page go (their value is in
     the field, not only in the picture); the other fields keep working.
     Returns the field and widget refs that were dropped. */
  function pruneFields(ctx, arr, hit, dropped){
    var out = [];
    arr.asArray().forEach(function(ref){
      var d = ctx.lookup(ref);
      if(!(d instanceof PDFLib.PDFDict)) return;
      var kids = d.lookup(pcN('Kids'));
      var kidRefs = kids instanceof PDFLib.PDFArray ? kids.asArray() : [];
      var terminal = !kidRefs.some(function(k){ return isField(ctx, k); });
      if(terminal){
        var all = [ref].concat(kidRefs);
        if(all.some(function(r){ return hit.has(r); })){ all.forEach(function(r){ dropped.add(r); }); return; }
        out.push(ref); return;
      }
      var left = pruneFields(ctx, kids, hit, dropped);
      if(!left.length){ dropped.add(ref); return; }
      d.set(pcN('Kids'), ctx.obj(left));
      out.push(ref);
    });
    return out;
  }
  function cleanForm(doc, hit){
    var ctx = doc.context, dropped = new Set();
    var acro = doc.catalog.lookup(pcN('AcroForm'));
    if(!(acro instanceof PDFLib.PDFDict)) return dropped;
    acro.delete(pcN('XFA')); // a second copy of the form data
    var fields = acro.lookup(pcN('Fields'));
    if(fields instanceof PDFLib.PDFArray) acro.set(pcN('Fields'), ctx.obj(pruneFields(ctx, fields, hit, dropped)));
    var co = acro.lookup(pcN('CO'));
    if(co instanceof PDFLib.PDFArray) acro.set(pcN('CO'), ctx.obj(co.asArray().filter(function(r){ return !dropped.has(r); })));
    return dropped;
  }
  function isScriptAction(ctx, a){
    var d = ctx.lookup(a);
    return d instanceof PDFLib.PDFDict && /^\/(JavaScript|Launch)$/.test(String(d.get(pcN('S'))));
  }
  /* A page without a box: no attachments, scripts or widgets of dropped fields. */
  function cleanAnnots(ctx, node, dropped){
    var a = node.lookup(pcN('Annots'));
    if(!(a instanceof PDFLib.PDFArray)) return;
    var keep = a.asArray().filter(function(r){
      if(dropped.has(r)) return false;
      var d = ctx.lookup(r);
      if(!(d instanceof PDFLib.PDFDict)) return false;
      if(DROP_ANNOT_SUBTYPES.indexOf(String(d.get(pcN('Subtype'))).slice(1)) >= 0) return false;
      d.delete(pcN('AA')); d.delete(pcN('AF')); // scripts, associated files
      if(isScriptAction(ctx, d.get(pcN('A')))) d.delete(pcN('A'));
      return true;
    });
    if(keep.length) node.set(pcN('Annots'), ctx.obj(keep)); else node.delete(pcN('Annots'));
  }
  /* ---- pictures and forms a page doesn't draw ----
     Some PDFs share one resource dictionary between all pages: a photo or a
     form that only a redacted page drew would stay in the file through the
     other pages. Each kept page gets its own copy with only the XObjects its
     content names (… /Im3 Do). Content that can't be decoded: kept as is. */
  var DO_RE = /\/([^\s\/\[\]()<>{}%]+)\s*Do\b/g;
  function decodeName(raw){ return raw.replace(/#([0-9A-Fa-f]{2})/g, function(_, h){ return String.fromCharCode(parseInt(h, 16)); }); }
  function streamText(s){
    if(!(s instanceof PDFLib.PDFRawStream)) return null;
    var bytes = PDFLib.decodePDFRawStream(s).decode(), out = '';
    for(var i = 0; i < bytes.length; i += 8192) out += String.fromCharCode.apply(null, bytes.subarray(i, i + 8192));
    return out;
  }
  function contentStreams(ctx, contents){
    var c = ctx.lookup(contents);
    if(c instanceof PDFLib.PDFArray) return c.asArray().map(function(r){ return ctx.lookup(r); });
    return c ? [c] : [];
  }
  /* The XObject names drawn by these streams (and by forms without resources of their own, which use the page's). */
  function namesDrawn(ctx, streams, xo, used, depth){
    streams.forEach(function(s){
      var text = streamText(s);
      if(text === null) throw new Error('undecodable content');
      var m;
      DO_RE.lastIndex = 0;
      while((m = DO_RE.exec(text))){
        var name = decodeName(m[1]);
        if(used.has(name)) continue;
        used.add(name);
        var form = ctx.lookup(xo.get(pcN(name)));
        if(depth > 0 && form instanceof PDFLib.PDFStream && !form.dict.has(pcN('Resources'))) namesDrawn(ctx, [form], xo, used, depth - 1);
      }
    });
    return used;
  }
  var FORM_DEPTH = 8;
  function ownResources(ctx, node){
    var res = node.Resources();
    if(!(res instanceof PDFLib.PDFDict)) return;
    var copy = ctx.obj({});
    res.entries().forEach(function(e){ copy.set(e[0], e[1]); });
    var xo = res.lookup(pcN('XObject'));
    if(xo instanceof PDFLib.PDFDict){
      var used = null;
      try{ used = namesDrawn(ctx, contentStreams(ctx, node.get(pcN('Contents'))), xo, new Set(), FORM_DEPTH); }
      catch(e){ used = null; } // content we can't decode: every XObject stays (never drop what the page may draw)
      if(used){
        var keep = ctx.obj({});
        xo.entries().forEach(function(e){ if(used.has(e[0].decodeText())) keep.set(e[0], e[1]); });
        copy.set(pcN('XObject'), keep);
      }
    }
    node.set(pcN('Resources'), copy);
  }
  /* Inherited resources live on the page tree's inner nodes: after every page got its own, they go. */
  function dropInheritedResources(ctx, ref, depth){
    var node = ctx.lookup(ref);
    if(!(node instanceof PDFLib.PDFDict) || String(node.get(pcN('Type'))) !== '/Pages' || depth < 0) return;
    node.delete(pcN('Resources'));
    var kids = node.lookup(pcN('Kids'));
    if(kids instanceof PDFLib.PDFArray) kids.asArray().forEach(function(k){ dropInheritedResources(ctx, k, depth - 1); });
  }
  var TREE_DEPTH = 64;
  var ID_LEN = 16;
  function freshId(ctx){
    var hex = Array.from(crypto.getRandomValues(new Uint8Array(ID_LEN)), function(b){ return (b < 16 ? '0' : '') + b.toString(16); }).join('');
    ctx.trailerInfo.ID = ctx.obj([PDFLib.PDFHexString.of(hex), PDFLib.PDFHexString.of(hex)]);
  }
  /* ---- (v157) what only a redacted page drew must not survive anywhere ----
     A picture or form under a box can still be reachable from a kept page
     without being drawn there: in the own /Resources of a form XObject, a
     pattern, a Type3 font or an annotation's appearance. Before the pages are
     replaced, every image, form and pattern a redacted page can reach is noted
     (secretsOf). After cleaning, everything the kept pages really draw is
     walked (drawnByKept); a secret that is not drawn is overwritten in place
     (neutralize), so no remaining reference can bring it back. */
  var NAME_RE = '\\/([^\\s\\/\\[\\]()<>{}%]+)';
  var USE_RES = [ // resource category, operator after the name
    ['XObject', new RegExp(NAME_RE + '\\s*Do\\b', 'g')],
    ['Pattern', new RegExp(NAME_RE + '\\s*(?:scn|SCN)\\b', 'g')],
    ['Font', new RegExp(NAME_RE + '\\s+[-+.\\d]+\\s+Tf\\b', 'g')],
    ['ExtGState', new RegExp(NAME_RE + '\\s*gs\\b', 'g')],
    ['Shading', new RegExp(NAME_RE + '\\s*sh\\b', 'g')]
  ];
  var WALK_DEPTH = 16;
  function isPageNode(o){
    if(!(o instanceof PDFLib.PDFDict)) return false;
    var tp = String(o.get(pcN('Type')));
    return tp === '/Page' || tp === '/Pages';
  }
  function isSecretKind(o){
    if(!(o instanceof PDFLib.PDFStream)) return false;
    var st = String(o.dict.get(pcN('Subtype')));
    return st === '/Image' || st === '/Form' || o.dict.has(pcN('PatternType'));
  }
  /* Every ref reachable from `start` without passing through another page (links, /P, /Parent). */
  function reachable(ctx, start, visit){
    var seen = new Set(), stack = [start];
    while(stack.length){
      var o = stack.pop();
      if(o instanceof PDFLib.PDFRef){
        if(seen.has(o)) continue;
        seen.add(o);
        var v = ctx.lookup(o);
        if(isPageNode(v)) continue;
        visit(o, v);
        o = v;
      }
      if(o instanceof PDFLib.PDFStream) o = o.dict;
      if(o instanceof PDFLib.PDFDict) o.entries().forEach(function(e){ if(e[0] !== pcN('Parent') && e[0] !== pcN('P')) stack.push(e[1]); });
      else if(o instanceof PDFLib.PDFArray) stack.push.apply(stack, o.asArray());
    }
  }
  /* The images, forms and patterns an (old) page node can reach: its resources, contents and annotations. */
  function secretsOf(ctx, node, into){
    ['Resources', 'Contents', 'Annots'].forEach(function(k){
      var v = node.get(pcN(k));
      if(!v) return;
      var holder = ctx.obj([v]); // a direct value is walked through a small array
      reachable(ctx, holder, function(ref, o){ if(isSecretKind(o)) into.add(ref); });
    });
    var inherited = node.lookup(pcN('Resources')) ? null : node.Resources && node.Resources(); // resources from the page tree
    if(inherited) reachable(ctx, ctx.obj([inherited]), function(ref, o){ if(isSecretKind(o)) into.add(ref); });
  }
  /* Marks what these streams draw, through the given resources (forms, patterns, Type3 glyphs, soft masks). */
  function walkDrawn(ctx, streams, res, drawn, depth){
    if(depth < 0) return;
    streams.forEach(function(s){
      var text = null;
      try{ text = streamText(s); }catch(e){ pcLogUnexpected(e); } // a filter pdf-lib can't decode: handled below
      if(text === null) throw new Error('undecodable content');
      USE_RES.forEach(function(u){
        var dict = res instanceof PDFLib.PDFDict ? res.lookup(pcN(u[0])) : null;
        if(!(dict instanceof PDFLib.PDFDict)) return;
        var m;
        u[1].lastIndex = 0;
        while((m = u[1].exec(text))) drawResource(ctx, u[0], dict.get(pcN(decodeName(m[1]))), res, drawn, depth);
      });
    });
  }
  function drawResource(ctx, kind, ref, res, drawn, depth){
    if(!ref) return;
    if(ref instanceof PDFLib.PDFRef){
      if(drawn.has(ref)) return;
      drawn.add(ref);
    }
    var o = ctx.lookup(ref);
    var ownRes = function(s){ return s.dict.lookup(pcN('Resources')) || res; };
    if(kind === 'XObject' || kind === 'Pattern'){
      if(o instanceof PDFLib.PDFStream && String(o.dict.get(pcN('Subtype'))) !== '/Image') walkDrawn(ctx, [o], ownRes(o), drawn, depth - 1);
      if(o instanceof PDFLib.PDFStream) ['SMask', 'Mask'].forEach(function(k){ var m = o.dict.get(pcN(k)); if(m instanceof PDFLib.PDFRef) drawn.add(m); }); // the picture's own mask
    }else if(kind === 'Font' && o instanceof PDFLib.PDFDict && String(o.get(pcN('Subtype'))) === '/Type3'){
      var procs = o.lookup(pcN('CharProcs')), fres = o.lookup(pcN('Resources')) || res;
      if(procs instanceof PDFLib.PDFDict) walkDrawn(ctx, procs.values().map(function(p){ return ctx.lookup(p); }), fres, drawn, depth - 1);
    }else if(kind === 'ExtGState' && o instanceof PDFLib.PDFDict){
      var sm = o.lookup(pcN('SMask'));
      var g = sm instanceof PDFLib.PDFDict ? sm.get(pcN('G')) : null;
      if(g) drawResource(ctx, 'XObject', g, res, drawn, depth - 1);
    }
  }
  /* The appearance streams of an annotation that stays (normal, rollover, down; one per state). */
  function appearanceStreams(ctx, annot){
    var ap = annot.lookup(pcN('AP')), out = [];
    if(!(ap instanceof PDFLib.PDFDict)) return out;
    ap.values().forEach(function(v){
      var o = ctx.lookup(v);
      if(o instanceof PDFLib.PDFStream) out.push(v);
      else if(o instanceof PDFLib.PDFDict) o.values().forEach(function(s){ if(ctx.lookup(s) instanceof PDFLib.PDFStream) out.push(s); });
    });
    return out;
  }
  /* Everything the kept pages draw. A kept page whose content can't be read keeps all it can reach (never drop what it may draw). */
  function drawnByKept(ctx, kept){
    var drawn = new Set();
    kept.forEach(function(node){
      var res = node.lookup(pcN('Resources'));
      try{
        walkDrawn(ctx, contentStreams(ctx, node.get(pcN('Contents'))), res, drawn, WALK_DEPTH);
        var annots = node.lookup(pcN('Annots'));
        if(annots instanceof PDFLib.PDFArray) annots.asArray().forEach(function(a){
          var d = ctx.lookup(a);
          if(d instanceof PDFLib.PDFDict) appearanceStreams(ctx, d).forEach(function(s){ drawResource(ctx, 'XObject', s, res, drawn, WALK_DEPTH); });
        });
      }catch(e){
        if(!/undecodable content/.test(e && e.message)) throw e;
        reachable(ctx, ctx.obj([node.get(pcN('Resources')) || ctx.obj({}), node.get(pcN('Annots')) || ctx.obj([])]), function(ref){ drawn.add(ref); });
      }
    });
    return drawn;
  }
  var BLANK_PIXEL = 255;
  function neutralize(ctx, ref){
    var o = ctx.lookup(ref);
    if(!(o instanceof PDFLib.PDFStream)) return;
    if(String(o.dict.get(pcN('Subtype'))) === '/Image'){
      ctx.assign(ref, ctx.stream(new Uint8Array([BLANK_PIXEL]), { Type: 'XObject', Subtype: 'Image', Width: 1, Height: 1, ColorSpace: 'DeviceGray', BitsPerComponent: 8 }));
      return;
    }
    // a form or tiling pattern: same kind, nothing drawn
    var keep = ctx.obj({});
    ['Type', 'Subtype', 'BBox', 'Matrix', 'PatternType', 'PaintType', 'TilingType', 'XStep', 'YStep'].forEach(function(k){ var v = o.dict.get(pcN(k)); if(v) keep.set(pcN(k), v); });
    keep.set(pcN('Resources'), ctx.obj({}));
    ctx.assign(ref, PDFLib.PDFRawStream.of(keep, new Uint8Array(0)));
  }
  /* (v157) Annotations of redacted pages that something else still points to (a reply's /IRT, a /Popup) are emptied. */
  function dropHitAnnots(ctx, kept, hit){
    var live = new Set();
    kept.forEach(function(node){ annotRefs(node).forEach(function(a){ live.add(a); }); });
    hit.forEach(function(ref){
      if(live.has(ref)) return;
      var d = ctx.lookup(ref);
      if(d instanceof PDFLib.PDFDict && !isPageNode(d)) ctx.assign(ref, PDFLib.PDFNull);
    });
    live.forEach(function(ref){
      var d = ctx.lookup(ref);
      if(!(d instanceof PDFLib.PDFDict)) return;
      ['IRT', 'Popup'].forEach(function(k){ if(hit.has(d.get(pcN(k)))) d.delete(pcN(k)); });
    });
  }
  /* kept: the page nodes without a box; hit: annotation refs of redacted pages; secrets: see secretsOf. */
  function redactClean(doc, kept, hit, secrets){
    var ctx = doc.context;
    var dropped = cleanForm(doc, hit);
    cleanCatalog(doc);
    kept.forEach(function(node){
      DROP_PAGE.forEach(function(k){ node.delete(pcN(k)); });
      cleanAnnots(ctx, node, dropped);
      ownResources(ctx, node);
    });
    dropHitAnnots(ctx, kept, hit);
    var drawn = drawnByKept(ctx, kept);
    secrets.forEach(function(ref){ if(!drawn.has(ref)) neutralize(ctx, ref); });
    dropInheritedResources(ctx, doc.catalog.get(pcN('Pages')), TREE_DEPTH);
    dropXmp(ctx);
    delete ctx.trailerInfo.Info; // title, author, producer…: the document information goes completely
    freshId(ctx);                // the old ID could tie this copy to the original
    pcCollectGarbage(doc); // old contents, fonts, pictures, bookmarks… really leave
  }

  async function openForRender(file){
    var task = pcGetDocument(pcPdfSource(new Uint8Array(await file.arrayBuffer())));
    try{ return { task: task, doc: await task.promise }; }
    catch(e){
      await destroyTask(task);
      pcThrowIfOutOfMemory(e);
      throw (e && e.userFacing) ? e : PCTools.userError(e && e.name === 'PasswordException' ? 'password' : 'invalidPdf');
    }
  }
  async function redactFile(file, boxes, ctx){
    var doc = await PCTools.loadPdfLib(file);
    var r = await openForRender(file);
    try{
      var pages = doc.getPages();
      if(pages.length !== r.doc.numPages) throw ownError('changed');
      var nums = Array.from(boxes.keys()).filter(function(n){ return n <= pages.length; }).sort(function(a, b){ return a - b; });
      var hit = new Set(), secrets = new Set();
      for(var i = 0; i < nums.length; i++){
        pcCheckCancel();
        ctx.setStatus(t('workingPage', nums[i], pages.length));
        var page = pages[nums[i] - 1];
        annotRefs(page.node).forEach(function(a){ hit.add(a); });
        hit.add(page.ref); // a widget pointing to this page (/P) without being in its list
        secretsOf(doc.context, page.node, secrets); // (v157) before the page is replaced
        var img = await renderRedacted(r.doc, nums[i], boxes.get(nums[i]));
        var image = img.png ? await doc.embedPng(img.bytes) : await doc.embedJpg(img.bytes);
        replacePage(doc, page.ref, page.node, image, img.size);
        ctx.setProgress((i + 1) / (nums.length + 1)); // pdf.js renders in its worker: every await hands the page back
      }
      pcCheckCancel();
      var set = new Set(nums);
      redactClean(doc, pages.filter(function(p, k){ return !set.has(k + 1); }).map(function(p){ return p.node; }), widgetsOn(doc.context, pages, hit), secrets);
      pcCheckCancel();
      var bytes = await pcSavePdf(doc, { useObjectStreams: true, updateFieldAppearances: false });
      return { blob: PCTools.pdfBlob(bytes), filename: baseFileName(file.name) + '-redacted.pdf', pages: nums };
    }finally{ await destroyTask(r.task); }
  }
  /* The annotations of redacted pages, plus any widget whose /P is one of those pages. */
  function widgetsOn(ctx, pages, hit){
    var all = new Set(hit);
    pages.forEach(function(p){
      annotRefs(p.node).forEach(function(a){
        var d = ctx.lookup(a);
        if(d instanceof PDFLib.PDFDict && hit.has(d.get(pcN('P')))) all.add(a);
      });
    });
    return all;
  }
  function boxesByPage(){
    var m = new Map();
    rd.boxes.forEach(function(list, page){ if(list.length) m.set(page, list.map(function(b){ return { x: b.x, y: b.y, w: b.w, h: b.h }; })); });
    rd.forced.forEach(function(page){ if(!m.has(page)) m.set(page, []); }); // (v157) a hidden match: the page becomes a picture too
    return m;
  }

  pcOnPanel('redact', function(){
    var layer = el('layer');
    if(!layer) return;
    setupDrawing(layer);
    el('prev').addEventListener('click', function(){ goPage(-1); });
    el('next').addEventListener('click', function(){ goPage(1); });
    el('undo').addEventListener('click', undo);
    el('remove').addEventListener('click', function(){ if(rd.selected) deleteBox(rd.selected); });
    el('find-btn').disabled = !rd.pdf; // (v153) nothing to search before a file is open
    el('find-btn').addEventListener('click', function(){ find().catch(pcLogUnexpected); });
    el('find').addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); if(rd.pdf) find().catch(pcLogUnexpected); } });
    var resizeTimer = null;
    window.addEventListener('resize', function(){
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function(){
        var stage = el('stage');
        if(!rd.pdf || isProcessing || !stage || stage.hidden) return;
        if(Math.min(R.PREVIEW_MAX_W, stage.parentElement.clientWidth || R.PREVIEW_MAX_W) !== rd.cssW) rerender();
      }, R.RESIZE_MS);
    });
    PCTools.setupTool('redact', {
      accept: PCTools.isPdf, working: function(){ return t('working'); }, zipName: 'redacted-pdf',
      onFiles: (function(gate){ return function(files){ gate(files[0] || null); }; })(PCTools.previewGate('redact', openPreview, function(){ return rd.previewFor; })),
      run: async function(files, _opt, ctx){
        if(files.length !== 1) throw ownError('one');
        PCTools.resetNotes();
        if(files[0] !== rd.boxFile || (!boxCount() && !rd.forced.size)){
          await PCTools.loadPdfLib(files[0]); // a damaged or protected file says so first, not "draw a box"
          throw ownError('noBoxes');
        }
        var boxes = boxesByPage();
        // like Crop: the preview's copy is closed while working (memory on a phone), then opened again
        var previewFile = rd.previewFor, r;
        openSeq++; rd.findSeq++;
        await closePreview();
        rd.previewFor = null;
        try{ r = await redactFile(files[0], boxes, ctx); }
        catch(e){ if(!pcIsCancel(e)) pcThrowIfOutOfMemory(e); throw e; } // a full memory is not a broken file
        finally{ if(previewFile && rd.previewFor === null) openPreview(previewFile).catch(pcLogUnexpected); }
        return { results: [{ blob: r.blob, filename: r.filename }], skipped: [],
          info: r.pages.length === 1 ? t('infoOne') : t('infoMany', r.pages.length),
          note: [t(r.pages.length === 1 ? 'noteOne' : 'noteMany', r.pages.join(', ')), t('note'), PCTools.takeNotes()].filter(Boolean).join(' ') };
      }
    });
  });
})();
